export enum RoleEnum {
    ROLE_USER = 'ROLE_USER',
    ROLE_OWNER = 'ROLE_OWNER',
    ROLE_MEMBER = 'ROLE_MEMBER',
    ROLE_SUPER_ADMIN = 'ROLE_SUPER_ADMIN',
}
